import React from 'react';
import Icon from '../../../components/AppIcon';

const DeveloperExperienceSection = () => {
  return (
    <section className="py-24 px-4 md:px-6 lg:px-8" style={{ backgroundColor: '#242423' }}>
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-start">
          
          {/* Left Column - Text Content */}
          <div>
            {/* Header with Icon */}
            <div className="flex items-center gap-4 mb-6">
              <div 
                className="w-12 h-12 rounded-lg flex items-center justify-center"
                style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}
              >
                <Icon name="Terminal" size={24} style={{ color: '#4FB3B8' }} />
              </div>
              <h3 className="text-2xl md:text-3xl font-bold" style={{ color: '#E8EDDF' }}>
                Developer-First, Agent-Based Framework
              </h3>
            </div>
            
            <p className="text-base mb-8 leading-relaxed" style={{ color: '#9CA3AF' }}>
              Define workflows declaratively using policy-as-code. Version control orchestration logic alongside application code. Visual debugger and simulation environment for testing multi-agent coordination before deployment to production infrastructure.
            </p>

            {/* Bullet Points */}
            <div className="space-y-3">
              <div className="flex items-center gap-3">
                <div className="w-2 h-2 rounded-full" style={{ backgroundColor: '#4FB3B8' }}></div>
                <p className="text-base" style={{ color: '#E8EDDF' }}>Declarative workflow definitions with policy-as-code</p>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-2 h-2 rounded-full" style={{ backgroundColor: '#4FB3B8' }}></div>
                <p className="text-base" style={{ color: '#E8EDDF' }}>Visual debugger for multi-agent coordination</p>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-2 h-2 rounded-full" style={{ backgroundColor: '#4FB3B8' }}></div>
                <p className="text-base" style={{ color: '#E8EDDF' }}>Version control integration for orchestration logic</p>
              </div>
            </div>
          </div>
          
          {/* Right Column - Code Block */}
          <div>
            <div className="rounded-xl overflow-hidden" style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}>
              
              {/* Window Chrome */}
              <div className="px-4 py-3 flex items-center gap-3" style={{ backgroundColor: '#242423', borderBottom: '1px solid #3A3A38' }}>
                <div className="flex gap-2">
                  <div className="w-3 h-3 rounded-full" style={{ backgroundColor: '#FF6B6B' }}></div>
                  <div className="w-3 h-3 rounded-full" style={{ backgroundColor: '#F5CB5C' }}></div>
                  <div className="w-3 h-3 rounded-full" style={{ backgroundColor: '#4FB3B8' }}></div>
                </div>
                <span style={{ color: '#9CA3AF', fontSize: '13px' }}>Workflow</span>
              </div>
              
              {/* Code Content */}
              <div className="p-6 font-mono text-sm leading-relaxed" style={{ backgroundColor: '#2E2E2C' }}>
                <div>
                  <span style={{ color: '#4FB3B8' }}>name:</span>
                  <span style={{ color: '#E8EDDF' }}> Manufacturing Cell Orchestration</span>
                </div>
                <div>
                  <span style={{ color: '#4FB3B8' }}>version:</span>
                  <span style={{ color: '#E8EDDF' }}> 1.2.0</span>
                </div>
                <div className="mt-4">
                  <span style={{ color: '#4FB3B8' }}>agents:</span>
                </div>
                <div className="ml-4">
                  <span style={{ color: '#9CA3AF' }}>- </span>
                  <span style={{ color: '#F5CB5C' }}>robotic_cell_1</span>
                  <span style={{ color: '#9CA3AF' }}>: </span>
                  <span style={{ color: '#E8EDDF' }}>edge/berlin-factory</span>
                </div>
                <div className="ml-4">
                  <span style={{ color: '#9CA3AF' }}>- </span>
                  <span style={{ color: '#F5CB5C' }}>quality_inspector</span>
                  <span style={{ color: '#9CA3AF' }}>: </span>
                  <span style={{ color: '#E8EDDF' }}>cloud/eu-west-1</span>
                </div>
                <div className="ml-4">
                  <span style={{ color: '#9CA3AF' }}>- </span>
                  <span style={{ color: '#F5CB5C' }}>maintenance_ai</span>
                  <span style={{ color: '#9CA3AF' }}>: </span>
                  <span style={{ color: '#E8EDDF' }}>edge/berlin-factory</span>
                </div>
                <div className="mt-4">
                  <span style={{ color: '#4FB3B8' }}>policies:</span>
                </div>
                <div className="ml-4">
                  <span style={{ color: '#9CA3AF' }}>- </span>
                  <span style={{ color: '#E8EDDF' }}>human_approval_required: </span>
                  <span style={{ color: '#E8EDDF' }}>true</span>
                </div>
                <div className="ml-4">
                  <span style={{ color: '#9CA3AF' }}>- </span>
                  <span style={{ color: '#E8EDDF' }}>failover_to_cloud: </span>
                  <span style={{ color: '#E8EDDF' }}>on_edge_unavailable</span>
                </div>
                <div className="mt-4">
                  <span style={{ color: '#4FB3B8' }}>workflow:</span>
                </div>
                <div className="ml-4">
                  <span style={{ color: '#9CA3AF' }}>1. </span>
                  <span style={{ color: '#E8EDDF' }}>detect_anomaly </span>
                  <span style={{ color: '#4FB3B8' }}>→</span>
                  <span style={{ color: '#E8EDDF' }}> quality_inspector</span>
                </div>
                <div className="ml-4">
                  <span style={{ color: '#9CA3AF' }}>2. </span>
                  <span style={{ color: '#E8EDDF' }}>analyze </span>
                  <span style={{ color: '#4FB3B8' }}>→</span>
                  <span style={{ color: '#E8EDDF' }}> maintenance_ai</span>
                </div>
                <div className="ml-4">
                  <span style={{ color: '#9CA3AF' }}>3. </span>
                  <span style={{ color: '#E8EDDF' }}>await_approval </span>
                  <span style={{ color: '#4FB3B8' }}>→</span>
                  <span style={{ color: '#E8EDDF' }}> human_operator</span>
                </div>
                <div className="ml-4">
                  <span style={{ color: '#9CA3AF' }}>4. </span>
                  <span style={{ color: '#E8EDDF' }}>execute_repair </span>
                  <span style={{ color: '#4FB3B8' }}>→</span>
                  <span style={{ color: '#E8EDDF' }}> robotic_cell_1</span>
                </div>
              </div>
            </div>
          </div>
          
        </div>
      </div>
    </section>
  );
};

export default DeveloperExperienceSection;